import React, { useState, useEffect } from "react";

import { loginRequest, protectedResources } from "../../authConfig";
import {
  useGetSkillPathData,
  useUpdateSkillPathData,
} from "../../hooks/useSkillPathData";
import { ISkillPath } from "../../model/SkillPath.model";
import { IsCookieFunction, useNavigate } from "react-router-dom";
import useFetchWithMsal from "../../hooks/useFetchWithMsal";
import EditSkillPathAttributesComponent from "./EditSkillPathAttributesComponent";
import EditSkillGroupComponent from "./EditSkillGroupComponent";
import AddSkillGroupFormComponent from "./AddSkillGroupFormComponent";
import { ISkillGroup } from "../../model/SkillGroup.model";
import { ISkillLevel } from "../../model/SkillLevel.model";
import EditSkillLevelsComponent from "./EditSkillLevelsComponent";
import Modal from "../Modal/Modal";
import AddSkillPathFormComponent from "./AddSkillPathFormComponent";


export interface SkillPathIdComponentState {
  id: any;
  parentid: string | undefined;
  skillPath: ISkillPath;
  skillLevels: ISkillLevel[];
  addSkillPath(event: ISkillPath): void;
}

const EditSkillPathComponent: React.FC<SkillPathIdComponentState> = ({
  id,
  parentid,
  skillPath,
  skillLevels,
  addSkillPath
}) => {
  const initialData = JSON.parse(JSON.stringify(skillPath));
  const [item, setItem] = useState(skillPath);
  const [skillPathId, setSkillPathId] = useState(id);
  const { error, execute } = useFetchWithMsal({
    scopes: protectedResources.apiCFSkillPath.scopes.read,
  });
  const [loading, setLoading] = useState(true);
  const [callErr, setErr] = useState(null);
  const [maxIndex, setMaxIndex] = useState(0);
  const [addingSubPath, setAddingSubPath] = useState(false);

  /* #region Functions */
  const handleEditAttributesTask = (skillPathUpdated: ISkillPath) => {
    execute("PUT", `/api/SkillPath/updateSkillPath`, skillPathUpdated)
      .then((response: any) => {
        item.skillPathName = response.skillPathName;
        item.skillPathDescription = response.skillPathDescription;
        setItem(item);
        setLoading(false);
      })
      .catch((err: any) => {
        setErr(err);
        setLoading(false);
      });
  };

  const handleNewGroupCreated = (groupCreated: ISkillGroup) => {
    console.log('handleNewGroupCreated called', groupCreated);
    if (item.skillGroups) {
      item.skillGroups.push(groupCreated);
    } else {
      item.skillGroups = [groupCreated];
    }
    setItem(item);
    regenerateMaxSGIndex();
  };
  const regenerateMaxSGIndex = () => {
    if (skillPath.skillGroups) {
      var t = skillPath.skillGroups.reduce((v, sg) => {
        console.log(v, sg.indexNumber);
        if (sg.indexNumber > v) {
          return sg.indexNumber;
        }
        return v;
      }, 0);
      if (maxIndex != t) setMaxIndex(t);
    }
  };
  const handleSkillLevelUpdate = (event: any) => {
    skillLevels = event;
  }
  const navigate = useNavigate();
  const SetSubSkillPath = (event: any) => {
    //const navigate = useNavigate();
    if (event.target.value === 'Select Discipline') {
      return;
    }
    //var id = event.target.value;
    navigate(`/admin/editskillpath/${id}/${event.currentTarget.value}`);
    //window.open(`/admin/editskillpath/2/${id}`, "_self");
  }
  const ToggleAddSubPath = (event:boolean) => {

    setAddingSubPath(event);
  }
  const HandleNewSkillPathCreated = (event:any) => {
    setAddingSubPath(false);
    addSkillPath(event as ISkillPath);
  }
  const handleSkillGroupDeleted = (group:ISkillGroup) => {
    if (item.skillGroups) {
      item.skillGroups.splice(item.skillGroups.indexOf(group),1);
    } else {
      //item.skillGroups = [groupCreated];
    }
    setItem(item);
    regenerateMaxSGIndex();
  }

  /* #endregion Functions */

  regenerateMaxSGIndex();

  return (
    <>
      <fieldset aria-labelledby='edit-skill-selector-heading' className='max-width m-t-2 bg-white thick-border rounded'>
        <legend className="on-admin clr-primary">
          <h3 id='edit-skill-selector-heading' className='p-l--50 p-r--50 fnt-wght-700 ltr-spcng-normal m-b-0 m-t-0'>Edit Skill Path</h3>
        </legend>
        <div className="aln-center">
          <h4 className="m-t-0 m-b--50 fnt-wght-700 ltr-spcng-normal clr-primary">{skillPath.skillPathName}</h4>
          <EditSkillPathAttributesComponent
            skillPath={skillPath}
            updateSkillPathData={handleEditAttributesTask}
          />
        </div>

        {skillPath && (skillPath as any).subSkillPaths !== undefined && (skillPath as any).subSkillPaths.length > 0 && (
          <div className="aln-center m-t-2">
            <div className="m-b-1">
              <select onChange={SetSubSkillPath}>
                <option>Select Discipline</option>
                {(skillPath as any).subSkillPaths.sort((a:ISkillPath, b:ISkillPath) => {if (a.skillPathName>b.skillPathName) return 1; return -1;}).map((sp: ISkillPath) => (<option value={sp.skillPathId}>{sp.skillPathName}</option>))}
              </select>
            </div>
            <button className="btn-secondary" value={'Add Discipline'} onClick={(event:any) => ToggleAddSubPath(true)}>Add Discipline</button>
          </div>
        )}

      </fieldset>

      {skillPath && (skillPath as any).subSkillPaths !== undefined && (skillPath as any).subSkillPaths.length < 1 && (
      <fieldset aria-labelledby='edit-skill-selector-heading' className='max-width m-t-2 bg-white thick-border rounded'>
        <legend>
          <h3 id='edit-skill-levels-heading' className='p-l--50 p-r--50 fnt-wght-700 ltr-spcng-normal m-b-0 m-t-0 clr-primary'>Edit Skill Levels</h3>
        </legend>
        <EditSkillLevelsComponent
          skillPathId={skillPathId}
          skillLevels={skillLevels}
          updateSkillLevelData={handleSkillLevelUpdate} />
      </fieldset>)}

      {skillPath && (skillPath as any).subSkillPaths !== undefined && (skillPath as any).subSkillPaths.length < 1 && (
      <fieldset aria-labelledby='edit-skill-groups-selector-heading' className='max-width m-t-2 bg-white thick-border rounded'>
        <legend className="on-admin clr-primary">
          <h3 id='edit-skill-groups-selector-heading' className='p-l--50 p-r--50 fnt-wght-700 ltr-spcng-normal'>Edit Skill Groups</h3>
        </legend>
          <div className="adminSkillGroups">
            {item.skillGroups &&
              item.skillGroups.length > 0 &&
              item.skillGroups.map((sg: any, index:number) => (
                <>
                  <EditSkillGroupComponent
                    key={sg.skillGroupId + index}
                    id={sg.skillGroupId}
                    skillGroup={sg}
                    skillLevels={skillLevels} skillGroupDeleted={handleSkillGroupDeleted}
                  />
                </>
              ))}
          </div>
          <>
              <AddSkillGroupFormComponent
                skillPathId={skillPathId}
                maxIndex={maxIndex}
                newGroupCreated={handleNewGroupCreated}
              />
            </>
      </fieldset>)}
      
      {addingSubPath && (
        <>
        <Modal modalTitle="New Skill Path" isOpen={addingSubPath} hasCloseBtn={true} onClose={() => ToggleAddSubPath(false)}>
          <AddSkillPathFormComponent parentSkillPathId={(!parentid) ? id : parentid} maxIndex={29} newSkillPathCreated={HandleNewSkillPathCreated} />
        </Modal>
        </>)}
    </>
  );
};
export default EditSkillPathComponent;
